import { render, staticRenderFns } from "./writeDialog.vue?vue&type=template&id=445b13f4&scoped=true&"
import script from "./writeDialog.vue?vue&type=script&lang=js&"
export * from "./writeDialog.vue?vue&type=script&lang=js&"
import style0 from "./writeDialog.vue?vue&type=style&index=0&id=445b13f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b13f4",
  null
  
)

export default component.exports